 
import {
  UserCircleIcon,
  ShieldCheckIcon,
  CubeTransparentIcon,
} from "@heroicons/react/24/outline";
import clsx from "clsx";
import { UserRole } from "../../../../enums";

export default function Role({ status }: { status: string }) {

  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-full px-2 py-1 text-xs",
        {
          "bg-cyan-600 text-white": status === UserRole.SUPERADMIN,
          "bg-cyan-400 text-white": status === UserRole.ADMIN,
          "bg-purple-400 text-white": status === UserRole.USER,
        }
      )}
    >
      {status === UserRole.SUPERADMIN ? (
        <>
          Super Admin
          <CubeTransparentIcon className="ml-1 w-4 text-white" />
        </>
      ) : null}
      {status === UserRole.ADMIN ? (
        <>
          Admin
          <ShieldCheckIcon className="ml-1 w-4 text-white" />
        </>
      ) : null}
      {status === UserRole.USER ? (
        <>
          User
          <UserCircleIcon className="ml-1 w-4 text-white" />
        </>
      ) : null}
    </span>
  );
}
